import { useEffect } from "react";

import { isInProductJourneySubAnchor } from "src/pages/software/confluence/anchors/subAnchors/subAnchor-util";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";

import { ConfluenceBackground } from "@/components/signup/confluence-background";
import {
    useSearchParameters,
    useSubanchorContext
} from "@/components/signup/hooks";
import {
    UfoCustomTimingKey,
    UfoCustomTimingWrapper,
    ufoEventRedirectToProduct
} from "@/components/signup/utils";
import { useUserContext } from "@/components/user-context";
import { useFeatureExposed } from "@/utils/feature-exposed";

import { useCloudStatus, useCloudStatusRedirection } from "../../hooks";

import { LoadingAnimation } from "./loading-animation";

export const ConfluenceProvisioningUi = () => {
    const { triggerOnSuccess, startPerceivedProvisioningTimer } =
        useCloudStatus();
    const { redirectUrl } = useCloudStatusRedirection();
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const {
        profile: { attributes }
    } = useUserContext();
    const { templateId } = useSearchParameters();
    const { subAnchor } = useSubanchorContext();
    const hasTargetedSubAnchor = isInProductJourneySubAnchor(subAnchor);

    const sites = attributes?.existingSites;
    const hasOnlyConfluenceSites = sites
        ? sites.every((site) => {
              const products = site.products;
              return products.every(
                  ({ productName }) => productName === "confluence"
              );
          })
        : true;

    const isXflow = !hasOnlyConfluenceSites;

    const isEligibleForTailorSubAnchorJourneyExp =
        !isXflow && !templateId && hasTargetedSubAnchor;

    useFeatureExposed(
        "cfind-3233-in-product-sub-anchors-journeys",
        "enrolled",
        { conditions: [isEligibleForTailorSubAnchorJourneyExp] }
    );

    useEffect(() => {
        startPerceivedProvisioningTimer();
    }, [startPerceivedProvisioningTimer]);

    useEffect(() => {
        if (redirectUrl) {
            ufoEventRedirectToProduct.success({
                customData: {
                    reactComponent: "ConfluenceLayout default",
                    analyticsEvent: "redirected",
                    redirectFrom: "confirmationPage",
                    provisioningStatus: "success"
                }
            });
            window.location.assign(redirectUrl);
        }
    }, [createAnalyticsEvent, triggerOnSuccess, redirectUrl]);

    return (
        <div data-testid="confluence-provisioning-ui">
            <UfoCustomTimingWrapper
                ufoEvent={ufoEventRedirectToProduct}
                ufoCustomTimingKey={
                    UfoCustomTimingKey.CONFLUENCE_ONBOARDING_SPINNER_DWELL_TIME
                }
            >
                <ConfluenceBackground />
                <LoadingAnimation isLoadingComplete={triggerOnSuccess} />
            </UfoCustomTimingWrapper>
        </div>
    );
};
